// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__hT-Op","solid":"style_solid__k89+U","gradient":"style_gradient__En6pC","image":"style_image__WWuWm","container":"style_container__F2Pim"};